import React, { useState, useEffect } from 'react';
import Menu from '../../elements/Menu/menu';
import CheckAuth from '../../elements/checkAuth';
import './referralStructure.css';
import '../../../../styles/table.admin.css';
import getUrlParams from '../../../elements/getUrlParams';
import config from '../../../../config/environment';
import axios from 'axios';
import PageMode from '../../elements/PageMode/pageMode';

const MODES = [ 'REFERRALS', 'ANALYTICS' ];

export default function ReferralStructure() {
    const [state, setState] = useState({
        cashbackToken: null,
        referralStructure: null,
        label: null,
        secondaryLabel: null,
        walletBalancesData: null,
        onlyTrueSuccessfulOrders: false,
        onlyTrueWalletBalances: false,

        mode: 'REFERRALS',

        childrenActivePage: 1,
        grandChildrenActivePage: 1
    });

    useEffect(() => {
        const main = async () => {
            const urlParamsObj = getUrlParams();

            if (!urlParamsObj.cashbackToken) { return; }

            const referralStructure = await getReferralStructure(urlParamsObj.cashbackToken);
            if (!referralStructure) { return; }

            setState(state => { return {
                ...state,
                cashbackToken: urlParamsObj.cashbackToken,
                referralStructure,
                label: referralStructure.label || null,
                secondaryLabel: referralStructure.secondaryLabel || null
            } });
        };
        main();
    }, []);

    const getReferralStructure = async (cashbackToken) => {
        if (!cashbackToken) { return; }

        try {
            const response = await axios.get(config.backendUrl + '/cashback/referral-structure?cashbackToken=' + cashbackToken, { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } });
            // console.log(response.data); // for debugging
            return response.data;
            
        } catch (error) {
            console.log(error.message);
            console.log(error.response.data.message);
            alert(error.message);
            return null;
        }
    };

    // Mode
    const modeOnChangeHandler = (event) => setState({...state, mode: event.target.value });

    // Main input
    const mainInputChangeHandler = (event) => setState({ ...state, cashbackToken: event.target.value });

    const mainGetButtonHandler = async () => {
        const referralStructure = await getReferralStructure(state.cashbackToken);
        if (!referralStructure) { return; }

        setState(state => { return {
            ...state,
            referralStructure,
            label: referralStructure.label || null,
            secondaryLabel: referralStructure.secondaryLabel || null
        }; });
        console.log(referralStructure);
    };

    const renderMainInput = () => {
        return(
            <div className="referralStructure__mainInput_wrapper">
                <input className="referralStructure__mainInput" placeholder="token / link / ETH address" type="text"
                    value={ state.cashbackToken || '' } onChange={ mainInputChangeHandler }/>
                <button onClick={ mainGetButtonHandler }>Get</button>
            </div>
        );
    };

    // Basic info
    const mainLabelInputHandler = (key) => (event) => {
        const newState = { ...state };
        newState[key] = event.target.value;
        setState(() => { return newState; });
    };

    const mainLabelSaveButtonHandler = (labelType) => async () => {
        try {
            const body = {
                cashbackToken: state.cashbackToken,
                labelType,
                label: state[labelType]
            };

            const response = await axios.post(config.backendUrl + '/cashback/save-label', body, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                }
            });

            alert(response.data.message);

        } catch(error) {
            console.log(error.message);
            console.log(error.response.data.message);
        }
    };

    const checkBalances = async () => {
        try {
            const cashbackTokensArray = [
                state.referralStructure.cashbackToken,
                ...state.referralStructure.childrenArray.map(userInfo => userInfo.cashbackToken),
                ...state.referralStructure.grandChildrenArray.map(userInfo => userInfo.cashbackToken)
            ];
        
            const response = await axios.post(config.backendUrl + '/cashback/wallet-balances', { cashbackTokensArray }, { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } });

            setState(state => { return { ...state, walletBalancesData: response.data }; });

        } catch(error) {
            console.log(error.message);
            console.log(error.response.data.message);
        }
    };

    const renderBasicInfoWalletBalances = () => {
        if (!state.walletBalancesData) { return; }

        const walletBalanceInfo = state.walletBalancesData.users[ state.referralStructure.cashbackToken ] || null;

        return(
            <>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Wallet balance:</span>
                    <span>{ walletBalanceInfo ? (walletBalanceInfo.max !== 0 ? ('true [max: ' + walletBalanceInfo.max + ' USD]') : 'false') : 'false' }</span>
                </div>
            </>
        );
    };

    const resetCashbackBalance = async () => {
        const txHash = prompt('Enter tx hash');
        if (!txHash) { alert('Invalid tx hash'); return; }

        const token2fa = prompt('Enter 2FA token');
        if (!token2fa) { alert('Invalid 2FA token'); return; }

        const body = {
            cashbackToken: state.cashbackToken,
            txHash,
            token2fa
        };

        await axios.post(config.cashbackUrl + '/set-zero-cashback', body)
        .then(() => alert('Success. Please, update info by "Get" button.'))
        .catch(error => {
            console.log(error.response ? error.response.data : error.message);
        });
    };

    const resetCpaBalance = async () => {
        const txHash = prompt('Enter tx hash');
        if (!txHash) { alert('Invalid tx hash'); return; }

        const token2fa = prompt('Enter 2FA token');
        if (!token2fa) { alert('Invalid 2FA token'); return; }

        const body = {
            cashbackToken: state.cashbackToken,
            txHash,
            token2fa
        };

        await axios.post(config.cashbackUrl + '/set-zero-cpa-balance', body)
        .then(() => alert('Success. Please, update info by "Get" button.'))
        .catch(error => {
            console.log(error.response ? error.response.data : error.message);
        });
    };

    const renderBasicInfo = () => {
        if (!state.referralStructure) { return; }

        return(
            <div className="referralStructure__basicInfo_wrapper">
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Registered:</span>
                    <span>{ state.referralStructure.createdAt }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Token:</span>
                    <span><a href={ '/skr/order-info?cashbackToken=' + state.referralStructure.cashbackToken } target="_blank">{ state.referralStructure.cashbackToken }</a></span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Label:</span>
                    <input placeholder="No label" type="text" value={ state.label || '' } onChange={ mainLabelInputHandler('label') }/>
                    <button className="referralStructure__basicInfo_button" onClick={ mainLabelSaveButtonHandler('label') }>Save</button>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Secondary label:</span>
                    <input placeholder="No label" type="text" value={ state.secondaryLabel || '' } onChange={ mainLabelInputHandler('secondaryLabel') }/>
                    <button className="referralStructure__basicInfo_button" onClick={ mainLabelSaveButtonHandler('secondaryLabel') }>Save</button>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Parent:</span>
                    <span>{
                        state.referralStructure.parent ?
                            <a href={ '/skr/order-info?cashbackToken=' + state.referralStructure.parent.cashbackToken } target="_blank">{ state.referralStructure.parent.cashbackToken + ' [' + (state.referralStructure.parent.label || 'No label') + ']' }</a>
                            : '–'
                    }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Grandparent:</span>
                    <span>{
                        state.referralStructure.grandParent ?
                            <a href={ '/skr/order-info?cashbackToken=' + state.referralStructure.grandParent.cashbackToken } target="_blank">{ state.referralStructure.grandParent.cashbackToken + ' [' + (state.referralStructure.grandParent.label || 'No label') + ']' }</a>
                            : '–'
                    }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Total users:</span>
                    <span>{ state.referralStructure.totalUsers || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Total children:</span>
                    <span>{ state.referralStructure.totalChildren || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Total grandchildren:</span>
                    <span>{ state.referralStructure.totalGrandChildren || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Cashback balance:</span>
                    <span>{ state.referralStructure.cashbackBalance || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Total cashback balance:</span>
                    <span>{ state.referralStructure.totalCashbackBalance || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Weekly volume:</span>
                    <span>{ state.referralStructure.weeklyVolume || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Overall volume:</span>
                    <span>{ state.referralStructure.overallVolume || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Fiat overall volume:</span>
                    <span>{ state.referralStructure.fiatOverallVolume || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Buy overall volume:</span>
                    <span>{ state.referralStructure.buyOverallVolume || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Sell overall volume:</span>
                    <span>{ state.referralStructure.sellOverallVolume || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Crypto overall volume:</span>
                    <span>{ state.referralStructure.cryptoOverallVolume || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">Level 2:</span>
                    <span>{ typeof state.referralStructure.isLevel2 !== 'undefined' ? state.referralStructure.isLevel2.toString() : 'false' }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">CPA balance:</span>
                    <span>{ state.referralStructure.cpaBalance || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">CPA total balance:</span>
                    <span>{ state.referralStructure.cpaTotalBalance || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">CPA 1 lvl users:</span>
                    <span>{ state.referralStructure.cpaLevel1Users || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">CPA 2 lvl users:</span>
                    <span>{ state.referralStructure.cpaLevel2Users || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <span className="referralStructure__basicInfo_label">CPA 3 lvl users:</span>
                    <span>{ state.referralStructure.cpaLevel3Users || 0 }</span>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <button onClick={ checkBalances } >Check balances</button>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <button onClick={ resetCashbackBalance } >Reset Cashback balance</button>
                </div>
                <div className="referralStructure__basicInfo_element">
                    <button onClick={ resetCpaBalance } >Reset CPA balance</button>
                </div>
                { renderBasicInfoWalletBalances() }
            </div>
        );
    };

    // Referrals
    const renderTables = () => {
        if (!state.referralStructure) { return; }

        return(
            <div className="referralStructure__tables_wrapper">
                { renderChildrenTable('children') }
                { renderChildrenTable('grandChildren') }
            </div>
        );
    };

    const tableSecondaryLabelInputHandler = (cashbackToken, arrayName) => (event) => {
        const newState = { ...state };
        const index = newState.referralStructure[arrayName + 'Array'].findIndex(userInfo => userInfo.cashbackToken === cashbackToken);
        newState.referralStructure[arrayName + 'Array'][index].secondaryLabel = event.target.value;
        setState(() => { return newState; });
    };

    const tableSecondaryLabelButtonHandler = (cashbackToken, arrayName) => async () => {
        try {
            const userInfo = state.referralStructure[arrayName + 'Array'].find(userInfo => userInfo.cashbackToken === cashbackToken);

            const body = {
                cashbackToken,
                labelType: 'secondaryLabel',
                label: userInfo.secondaryLabel
            };

            const response = await axios.post(config.backendUrl + '/cashback/save-label', body, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                }
            });

            alert(response.data.message);

        } catch(error) {
            console.log(error.message);
            console.log(error.response.data.message);
        }
    };

    const getWalletDataInfo = (cashbackToken) => {
        if (!state.walletBalancesData) { return null; }
        return state.walletBalancesData.users[ cashbackToken ] || null;
    };

    const onlyTrueCheckboxHandler = (param) => (event) => {
        const newState = { ...state };
        newState[param] = event.target.checked;
        setState(() => { return newState; });
    };

    const renderChildrenTable = (arrayName) => {
        let array = state.referralStructure[arrayName + 'Array'];

        if (array.length === 0) { return; }

        if (state.onlyTrueSuccessfulOrders) { array = array.filter(userInfo => userInfo.isSuccessfulOrders); }
        if (state.onlyTrueWalletBalances) { array = array.filter(userInfo => {
            if (!state.walletBalancesData) { return true; }
            if (!state.walletBalancesData.users[ userInfo.cashbackToken ]) { return false; }
            if (state.walletBalancesData.users[ userInfo.cashbackToken ].max === 0) { return false; }
            return true;
        }); }

        return(
            <div className="referralStructure__table" >
                <span className="referralStructure__tables_label">{ arrayName.toUpperCase() }</span>
                <div>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Cashback token</th>
                                <th>
                                    Successful orders
                                    <div className="table__checkbox">
                                        <input type="checkbox" onChange={ onlyTrueCheckboxHandler('onlyTrueSuccessfulOrders') } checked={ state.onlyTrueSuccessfulOrders } />
                                        <span>only true</span>
                                    </div>
                                </th>
                                <th>Secondary label</th>
                                {
                                    state.walletBalancesData ?
                                    <th>
                                        Wallet balance
                                        <div className="table__checkbox">
                                            <input type="checkbox" onChange={ onlyTrueCheckboxHandler('onlyTrueWalletBalances') } checked={ state.onlyTrueWalletBalances } />
                                            <span>only true</span>
                                        </div>
                                    </th> : null
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                array.map((userInfo, index) => {
                                    const walletBalanceInfo = getWalletDataInfo(userInfo.cashbackToken);

                                    return(
                                        <tr key={ index }>
                                            <td>{ userInfo.createdAt }</td>
                                            <td>{ userInfo.cashbackToken }</td>
                                            <td>{ userInfo.isSuccessfulOrders.toString() }</td>
                                            <td>
                                                <input placeholder="secondary label" type="text" value={ userInfo.secondaryLabel || '' }
                                                    onChange={ tableSecondaryLabelInputHandler(userInfo.cashbackToken, arrayName) } />
                                                <button className="referralStructure__tables_button"
                                                    onClick={ tableSecondaryLabelButtonHandler(userInfo.cashbackToken, arrayName) } >Save</button>
                                            </td>
                                            {
                                                state.walletBalancesData ?
                                                <td>
                                                    { walletBalanceInfo ? (walletBalanceInfo.max !== 0 ? ('true [max: ' + walletBalanceInfo.max + ' USD]') : 'false') : 'false' }
                                                </td> : null
                                            }
                                        </tr>
                                    );
                                })
                            }
                            <tr><td colSpan={ !state.walletBalancesData ? 4 : 5 }>Total: { array.length }</td></tr>
                        </tbody>
                    </table>
                </div>
                <div className="referralStructure__tables_paginationWrapper">
                    { renderPagination(arrayName) }
                </div>
            </div>
        );
    };

    const renderPagination = (tableName) => {
        if (state.referralStructure[ tableName + 'Pages' ] <= 1) { return; }

        const resData = [];

        for (let i = 1; i <= state.referralStructure[ tableName + 'Pages' ]; i++) {
            resData.push(<span className={ i === state[ tableName + 'ActivePage' ] ? 'referralStructure__tables_paginationButtonSelected' : 'referralStructure__tables_paginationButton' }
                onClick={ paginationHandler(tableName, i) }>{ i }</span>);
        }

        return resData;
    };

    const paginationHandler = (tableName, page) => async () => {
        try {
            const response = await axios.get(config.backendUrl + '/cashback/referral-structure-page?cashbackToken=' + state.cashbackToken +
                '&page=' + page + '&tableName=' + (tableName === 'children' ? 'CHILDREN' : 'GRAND_CHILDREN'), { headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                } });
            
            const newState = { ...state };
            newState[ tableName + 'ActivePage' ] = page;
            newState.referralStructure[ tableName + 'Array' ] = response.data;

            setState(() => { return(newState); });

        } catch (error) {
            console.log(error.message);
            console.log(error);
            alert(error.message);
        }
    };

    // Analytics
    const renderAnalytics = () => {
        if (!state.referralStructure || !state.referralStructure.dynamicLinkAnalytics ||
            state.referralStructure.dynamicLinkAnalytics.length === 0) { return; }

        return(
            <div className="referralStructure__analytics_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Count</th>
                            <th>Event</th>
                            <th>Platform</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            state.referralStructure.dynamicLinkAnalytics.map((analyticsData, index) => {
                                return(
                                    <tr>
                                        <td>{ analyticsData.count }</td>
                                        <td>{ analyticsData.event }</td>
                                        <td>{ analyticsData.platform }</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <>
                { renderMainInput() }
                { renderBasicInfo() }
                <div className='pageMode__mobile'>
                    <PageMode modesArray={ MODES } checkedMode={ state.mode } onChangeHandler={ modeOnChangeHandler } />
                </div>
                { state.mode === 'REFERRALS' ? renderTables() : renderAnalytics() }
            </>
        </>
    );
};
